import { useState } from "react";
import { useSignal } from "@preact/signals-react";
import { FormattedMessage as FM } from "react-intl";

import Dialog from "componentsv2/modal/Dialog";
import { useWizard } from "storev2/wizardStore";
import BasicTable from "componentsv2/table/BasicTable";
import { cn } from "tools/ui";
import { BUTTON } from "theme/constants";

const styleBase =
  "flex w-full rounded-sm justify-center my-auto p-2 h-11 text-center border-b-[1px] shadow-md active:scale-95 active:shadow-lg";

function ModalTab(props) {
  const open = useSignal(false);
  const {
    layout,
    data,
    record,
    storeId,
    style,
    label,
    icon,
    color,
    resetData,
    buttons,
    onReset,
    handleAccept,
  } = props;
  const [msg, setMsg] = useState(null);
  const { reset } = useWizard();
  // const layoutTab = field.layout();
  const _color = color ?? "blue";
  const _style = style ?? "w-full";
  const themeBtn = BUTTON[_color];

  function onCloseMsg() {
    setMsg(null);
  }

  async function onClose(update, error) {
    if (error) {
      setMsg(error);
      reset();
      return;
    }

    open.value = false;
    reset();
    if (resetData) {
      for (const field of Object.values(resetData)) {
        field.value = null;
      }
    }
    if (onReset) {
      onReset();
    }
  }

  function openModal() {
    if (layout?.defaults) {
      // This method set default values for the wizard
      layout.defaults();
    }
    open.value = true;
  }

  let mxLabel = "mx-auto";
  if (icon) {
    mxLabel = "";
  }

  const count = data.value.size;
  const limit = 30;
  // console.log("data tab.........", data);
  return (
    <div className="flex w-full">
      <button
        type="button"
        onClick={openModal}
        className={cn(
          styleBase,
          themeBtn.bg,
          themeBtn.text,
          themeBtn.border,
          _style,
        )}
      >
        <span className={cn("w-fit my-auto", mxLabel)}>
          <FM id={label} />
        </span>
        <div
          className={cn(
            "flex w-7 h-7 my-auto mx-auto rounded-full p-1 justify-center",
            themeBtn.bgIcon,
            themeBtn.textIcon,
          )}
        >
          <span className="text-sm">{count}</span>
        </div>
      </button>
      <Dialog
        title={label}
        openModal={open}
        handleClose={onClose}
        handleAccept={handleAccept}
        buttons={buttons}
        titleSize="text-2xl"
        size="h-4/5 w-2/3"
      >
        <BasicTable
          storeId={storeId}
          layout={layout}
          records={data.value}
          limit={limit}
          countRecords={count}
        />
      </Dialog>
    </div>
  );
}

export default ModalTab;
